import { render } from "./UserAttributesLovValueDialog.vue?vue&type=template&id=bd0e953c&scoped=true&ts=true"
import script from "./UserAttributesLovValueDialog.vue?vue&type=script&lang=ts"
export * from "./UserAttributesLovValueDialog.vue?vue&type=script&lang=ts"

import "./UserAttributesLovValueDialog.vue?vue&type=style&index=0&id=bd0e953c&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd0e953c"]])

export default __exports__